import type { DamageType } from '@/common/damage';
import { axios } from '@/lib/utils/axios';
import { getResponse } from '../common';
import { API_URLS } from '../query.client';
import { toApiPayload } from './damage-mapper';

export type AddDamageSuccessResponseType = DamageType;

export async function addDamage(
	assetId: string,
	inspectionId: string,
	payload: Omit<DamageType, 'id'>
): Promise<AddDamageSuccessResponseType | null> {
	// Transform UI data to API structure
	const apiPayload = toApiPayload(payload, assetId, inspectionId);

	const response = await axios.post(`${API_URLS.DAMAGES.INDEX}`, apiPayload);

	return getResponse<AddDamageSuccessResponseType>(response.data);
}
